import { MEMBERACCESS_SUCCESS, MEMBERACCESS_FAIL } from '../actionTypes';

const initialState = {
    user: null,
    loading: false
};

const memberAccessReducer = (state = initialState, action) => {
    switch (action.type) {
        case MEMBERACCESS_SUCCESS:
            return {
                ...state,
                loading: true,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case MEMBERACCESS_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default memberAccessReducer;
